webpackJsonp([3],{

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(159);

var _components = __webpack_require__(783);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import ScrollAnimation from 'react-animate-on-scroll'
// import { RedirectProps } from 'react-static'


var Contact = function (_Component) {
  _inherits(Contact, _Component);

  function Contact() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Contact);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Contact.__proto__ || Object.getPrototypeOf(Contact)).call.apply(_ref, [this].concat(args))), _this), _this.submit = function (values) {
      // print the form values to the console
      // console.log(this.props)
      // console.log(values)

      // Save to local storage for data passing
      // const items = localStorage.setItem(values)

      var uriapp = "https://afrodesiamedia.com/admin/api/collections/save/contacts?token=7289370ee7736e97be508a8fba6003";

      var uriform = "https://afrodesiamedia.com/admin/api/forms/submit/contactus?token=7289370ee7736e97be508a8fba6003";

      // POST TO COLLECTION API

      fetch(uriapp, {
        method: 'post',
        // mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          data: values
        })

      }).then(function (collection) {
        return collection.json();
      }).then(function (collection) {
        return console.log(collection);
      });
      _this.props.history.push('/thank-you');
      localStorage.setItem('values', values);

      // POST TO FORM API 

      fetch(uriform, {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          form: values
        })
      }).then(function (entry) {
        return entry.json();
      });
      // .then(entry => console.log(entry));
      // this.props.history.push('/thank-you')
      // localStorage.setItem({form: values});
      //   console.log(values)
      // }
      console.log(values);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Contact, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          _reactHelmet.Helmet,
          null,
          _react2.default.createElement(
            "title",
            null,
            " Contact - afrodesiamedia "
          ),
          _react2.default.createElement("link", { rel: "shortcut icon", href: "/favicon.ico" }),
          _react2.default.createElement("meta", { property: "og:title", content: "Contact" })
        ),
        _react2.default.createElement(
          "section",
          { className: "Contact" },
          _react2.default.createElement(
            "header",
            { className: "heading" },
            _react2.default.createElement(
              "h1",
              null,
              "Contact"
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "container" },
            _react2.default.createElement(
              "div",
              { className: "form-holder" },
              _react2.default.createElement(
                "aside",
                null,
                _react2.default.createElement(
                  "div",
                  null,
                  _react2.default.createElement(
                    "h3",
                    null,
                    "Got something??"
                  ),
                  _react2.default.createElement(
                    "p",
                    null,
                    "Contact us for any inquiry about our services."
                  )
                )
              ),
              _react2.default.createElement(_components.ContactForm, { onSubmit: this.submit })
            )
          )
        )
      );
    }
  }]);

  return Contact;
}(_react.Component);

exports.default = Contact;

/***/ }),

/***/ 751:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 783:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactForm = undefined;

var _ContactForm = __webpack_require__(784);

var _ContactForm2 = _interopRequireDefault(_ContactForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ContactForm = _ContactForm2.default;

/***/ }),

/***/ 784:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reduxForm = __webpack_require__(262);

var _RenderFields = __webpack_require__(785);

var _RenderFields2 = _interopRequireDefault(_RenderFields);

var _RenderTextArea = __webpack_require__(786);

var _RenderTextArea2 = _interopRequireDefault(_RenderTextArea);

var _Validate = __webpack_require__(787);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactForm = function ContactForm(props) {
  var handleSubmit = props.handleSubmit,
      pristine = props.pristine,
      submitting = props.submitting;

  return _react2.default.createElement(
    'div',
    { className: 'form-wrap' },
    _react2.default.createElement(
      'form',
      { onSubmit: handleSubmit },
      _react2.default.createElement(_reduxForm.Field, {
        name: 'firstName',
        type: 'firstName',
        component: _RenderFields2.default,
        label: 'First Name',
        validate: _Validate.firstName
      }),
      _react2.default.createElement(_reduxForm.Field, {
        name: 'lastName',
        type: 'lastName',
        component: _RenderFields2.default,
        label: 'Last Name',
        validate: _Validate.lastName
      }),
      _react2.default.createElement(_reduxForm.Field, {
        name: 'email',
        type: 'email',
        component: _RenderFields2.default,
        label: 'Please add your Email',
        validate: [_Validate.email, _Validate.emailRequired],
        warn: _Validate.aol
      }),
      _react2.default.createElement(
        'div',
        { className: 'messagebox' },
        _react2.default.createElement(_reduxForm.Field, {
          name: 'message',
          label: 'Type your message',
          component: _RenderTextArea2.default,
          type: 'textarea',
          validate: _Validate.messageRequired
        })
      ),
      _react2.default.createElement(
        'button',
        { type: 'submit', disabled: pristine || submitting },
        'Submit'
      )
    )
  );
};

ContactForm = (0, _reduxForm.reduxForm)({
  // a unique name for the form
  form: 'contact'
})(ContactForm);

exports.default = ContactForm;

/***/ }),

/***/ 785:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(751);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RenderFields = function RenderFields(_ref) {
  var input = _ref.input,
      label = _ref.label,
      type = _ref.type,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      warning = _ref$meta.warning;
  return _react2.default.createElement(
    'div',
    { className: 'form-group' },
    _react2.default.createElement('input', _extends({}, input, { type: type, className: (0, _classnames2.default)('form-control') })),
    _react2.default.createElement(
      'label',
      null,
      label
    ),
    _react2.default.createElement(
      'div',
      { className: 'error' },
      touched && (error && _react2.default.createElement(
        'span',
        null,
        error
      ) || warning && _react2.default.createElement(
        'span',
        null,
        warning
      ))
    )
  );
};
exports.default = RenderFields;

/***/ }),

/***/ 786:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RenderTextArea = function RenderTextArea(_ref) {
  var input = _ref.input,
      label = _ref.label,
      type = _ref.type,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      warning = _ref$meta.warning;
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "label",
      null,
      label
    ),
    _react2.default.createElement(
      "div",
      { className: "error" },
      touched && (error && _react2.default.createElement(
        "span",
        null,
        error
      ) || warning && _react2.default.createElement(
        "span",
        null,
        warning
      ))
    ),
    _react2.default.createElement("textarea", _extends({}, input, { type: type }))
  );
};
exports.default = RenderTextArea;

/***/ }),

/***/ 787:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var label = exports.label = void 0;

var firstName = exports.firstName = function firstName(value) {
  return value || typeof value === 'number' ? undefined : 'Your first name is required!';
};
var lastName = exports.lastName = function lastName(value) {
  return value || typeof value === 'number' ? undefined : 'Your last name is required!';
};
var emailRequired = exports.emailRequired = function emailRequired(value) {
  return value || typeof value === 'number' ? undefined : 'Please provide and valid email!';
};
var phoneRequired = exports.phoneRequired = function phoneRequired(value) {
  return value || typeof value === 'number' ? undefined : 'Please provide and valid phone number!';
};
var messageRequired = exports.messageRequired = function messageRequired(value) {
  return value || typeof value === 'number' ? undefined : 'Please provide your message!';
};
var maxLength = exports.maxLength = function maxLength(max) {
  return function (value) {
    return value && value.length > max ? 'Must be ' + max + ' characters or less' : undefined;
  };
};
var maxLength15 = exports.maxLength15 = maxLength(15);
var minLength = exports.minLength = function minLength(min) {
  return function (value) {
    return value && value.length < min ? 'Must be ' + min + ' characters or more' : undefined;
  };
};
var minLength2 = exports.minLength2 = minLength(2);
var number = exports.number = function number(value) {
  return value && isNaN(Number(value)) ? 'Must be a number' : undefined;
};
var minValue = exports.minValue = function minValue(min) {
  return function (value) {
    return value && value < min ? 'Must be at least ' + min : undefined;
  };
};
var minValue13 = exports.minValue13 = minValue(13);
var email = exports.email = function email(value) {
  return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'Invalid email address' : undefined;
};
var tooYoung = exports.tooYoung = function tooYoung(value) {
  return value && value < 13 ? 'You do not meet the minimum age requirement!' : undefined;
};
var aol = exports.aol = function aol(value) {
  return value && /.+@aol\.com/.test(value) ? 'Really? You still use AOL for your email?' : undefined;
};
var alphaNumeric = exports.alphaNumeric = function alphaNumeric(value) {
  return value && /[^a-zA-Z0-9 ]/i.test(value) ? 'Only alphanumeric characters' : undefined;
};
var phoneNumber = exports.phoneNumber = function phoneNumber(value) {
  return value && !/^(0|[1-9][0-9]{9})$/i.test(value) ? 'Invalid phone number, must be 10 digits' : undefined;
};

/***/ })

});


// WEBPACK FOOTER //
// templates/src/pages/Contact/Contact.8f81dc13.js